"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "ui:layout": "section",
  "ui:title": "Bygningsdel",
  "ui:label": false,
  "ui:preview": {
    "select": {
      "description": "description"
    },

    prepare({
      formData,
      schema
    }) {
      const buildingPartId = formData.buildingPartId;
      let description = "Uten tittel";

      if (buildingPartId && schema.properties.buildingPartId.enum && schema.properties.buildingPartId.enumNames) {
        const index = schema.properties.buildingPartId.enum.indexOf(buildingPartId);
        description = schema.properties.buildingPartId.enumNames[index] || index;
      }

      return {
        description: description
      };
    }

  },
  "ui:options": {
    "grid": true,
    "spacing": 2,
    "collapsible": true
  },
  "ui:fieldset": ["buildingPartId", "costEstimate", "timeEstimate", "buildingDetails", "comments"],
  "buildingPartId": {
    "ui:title": "Bygningsdel",
    "ui:placeholder": "Søk og velg bygningsdel",
    "ui:widget": "autocomplete"
  },
  "costEstimate": {
    "ui:gridCols": 6,
    "ui:title": "Estimert kostnad",
    "ui:help": "Kostnad i kroner"
  },
  "timeEstimate": {
    "ui:gridCols": 6,
    "ui:title": "Estimert tidsbruk",
    "ui:help": "Estimert tidsbruk i antall timer"
  },
  "buildingDetails": {
    "ui:title": "Materialbruk, etc.",
    "ui:widget": "textarea",
    "ui:help": "Estimert materialbruk og andre detailejr"
  },
  "comments": {
    "ui:layout": "list",
    "ui:title": "Kommentarer",
    "ui:options": {
      "sortable": true
    },
    "ui:buttonGroupProps": {
      "fullWidth": true
    },
    "ui:buttons": {
      "label": "Legg til kommentar"
    },
    "items": {
      "ui:layout": "module",
      "ui:editable": true,
      "title": {
        "ui:title": "Kommentar",
        "ui:widget": "textarea"
      }
    }
  }
};
exports.default = _default;
module.exports = exports.default;